<p>
  Importing {{adId}}
</p>
<mat-progress-bar color="primary"  [mode]="'indeterminate'"></mat-progress-bar>
